import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2333 2333"
      id="vector">
      <g
        id="group"
        transform="translate(33 125)">
        <path
          id="path"
          d="M 737.5 0 L 1045 0.5 L 737.5 1 L 737.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 1224.5 0 L 1529 0.5 L 1224.5 1 L 1224.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 459.5 1 L 580 1.5 L 459.5 2 L 459.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 1686.5 1 L 1808 1.5 L 1686.5 2 L 1686.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 266.5 2 L 356 2.5 L 266.5 3 L 266.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 1910.5 2 L 2001 2.5 L 1910.5 3 L 1910.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 162.5 3 L 184 3.5 L 162.5 4 L 162.5 3 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 2083.5 3 L 2104 3.5 L 2083.5 4 L 2083.5 3 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 152.5 4 L 156 4.5 L 152.5 5 L 152.5 4 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 2110.5 4 L 2114 4.5 L 2110.5 5 L 2110.5 4 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 145.5 5 L 148 5.5 L 145.5 6 L 145.5 5 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 2118.5 5 L 2121 5.5 L 2118.5 6 L 2118.5 5 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 2124.5 6 L 2127 6.5 L 2124.5 7 L 2124.5 6 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 87.5 26 L 86.5 28 L 87.5 26 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 82.5 29 L 81.5 31 L 82.5 29 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 2185.5 30 L 2186.5 32 L 2185.5 30 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 79.5 31 L 78.5 33 L 79.5 31 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 2188.5 32 L 2189.5 34 L 2188.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 76.5 33 L 75.5 35 L 76.5 33 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 2191.5 34 L 2192.5 36 L 2191.5 34 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 73.5 35 L 72.5 37 L 73.5 35 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 2195.5 37 L 2196.5 39 L 2195.5 37 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 69.5 38 L 68.5 40 L 69.5 38 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 2199.5 40 L 2201.5 43 L 2199.5 40 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 64.5 42 L 62.5 45 L 64.5 42 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 2205.5 45 L 2208.5 49 L 2205.5 45 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 57.5 48 L 46.5 60 L 57.5 48 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 2219.5 59 L 2222.5 63 L 2219.5 59 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 42.5 64 L 40.5 67 L 42.5 64 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 2226.5 67 L 2227.5 69 L 2226.5 67 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 37.5 70 L 36.5 72 L 37.5 70 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 2229.5 71 L 2230.5 73 L 2229.5 71 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 34.5 74 L 33.5 76 L 34.5 74 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 2232.5 75 L 2233.5 77 L 2232.5 75 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 32.5 77 L 31.5 79 L 32.5 77 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 2234.5 78 L 2235.5 80 L 2234.5 78 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 30.5 80 L 29.5 82 L 30.5 80 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 2236.5 81 L 2237.5 83 L 2236.5 81 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 28.5 83 L 27.5 85 L 28.5 83 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 2238.5 84 L 2239.5 86 L 2238.5 84 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 25.5 88 L 24.5 90 L 25.5 88 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 1111.5 115 L 1232 115.5 L 1111.5 116 L 1111.5 115 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 1651.5 115 L 1742 115.5 L 1651.5 116 L 1651.5 115 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 926.5 116 L 1014 116.5 L 926.5 117 L 926.5 116 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 1807.5 116 L 1860 116.5 L 1807.5 117 L 1807.5 116 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 760.5 117 L 843 117.5 L 760.5 118 L 760.5 117 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 1906.5 117 L 1947 117.5 L 1906.5 118 L 1906.5 117 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 585.5 118 L 676 118.5 L 585.5 119 L 585.5 118 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 1983.5 118 L 2017 118.5 L 1983.5 119 L 1983.5 118 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 347.5 119 L 483 119.5 L 347.5 120 L 347.5 119 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 2048.5 119 L 2078 119.5 L 2048.5 120 L 2048.5 119 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 166.5 120 L 170 120.5 L 166.5 121 L 166.5 120 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 2096.5 120 L 2100 120.5 L 2096.5 121 L 2096.5 120 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 2121.5 128 L 2122.5 130 L 2121.5 128 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 2124.5 130 L 2125.5 132 L 2124.5 130 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 140.5 131 L 138.5 134 L 140.5 131 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 2129.5 134 L 2134.5 140 L 2129.5 134 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 5.5 137 L 6 139.5 L 5 139.5 L 5.5 137 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 131.5 140 L 129.5 143 L 131.5 140 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 2261.5 140 L 2262 142.5 L 2261 142.5 L 2261.5 140 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 4.5 142 L 5 144.5 L 4 144.5 L 4.5 142 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 2136.5 142 L 2137.5 144 L 2136.5 142 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 2262.5 145 L 2263 147.5 L 2262 147.5 L 2262.5 145 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 126.5 147 L 125.5 149 L 126.5 147 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 3.5 148 L 4 150.5 L 3 150.5 L 3.5 148 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 2140.5 148 L 2141.5 150 L 2140.5 148 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 2263.5 152 L 2264 154.5 L 2263 154.5 L 2263.5 152 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 2.5 154 L 3 158.5 L 2 158.5 L 2.5 154 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 2264.5 160 L 2265 166.5 L 2264 166.5 L 2264.5 160 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 119.5 163 L 120 165.5 L 119 165.5 L 119.5 163 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 1.5 165 L 2 363.5 L 1 363.5 L 1.5 165 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 2147.5 166 L 2148 168.5 L 2147 168.5 L 2147.5 166 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 118.5 168 L 119 172.5 L 118 172.5 L 118.5 168 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 2148.5 175 L 2149 200.5 L 2148 200.5 L 2148.5 175 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 2265.5 221 L 2266 338.5 L 2265 338.5 L 2265.5 221 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 117.5 229 L 118 300.5 L 117 300.5 L 117.5 229 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 2149.5 230 L 2150 259.5 L 2149 259.5 L 2149.5 230 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 2150.5 292 L 2151 325.5 L 2150 325.5 L 2150.5 292 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 2151.5 363 L 2152 402.5 L 2151 402.5 L 2151.5 363 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 116.5 371 L 117 440.5 L 116 440.5 L 116.5 371 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 2152.5 448 L 2153 498.5 L 2152 498.5 L 2152.5 448 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 115.5 512 L 116 588.5 L 115 588.5 L 115.5 512 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 2153.5 562 L 2154 649.5 L 2153 649.5 L 2153.5 562 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 0.5 630 L 1 1278.5 L 0 1278.5 L 0.5 630 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 114.5 677 L 115 798.5 L 114 798.5 L 114.5 677 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 2265.5 906 L 2266 1159.5 L 2265 1159.5 L 2265.5 906 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 2153.5 937 L 2154 1025.5 L 2153 1025.5 L 2153.5 937 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 114.5 1045 L 115 1141.5 L 114 1141.5 L 114.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 2152.5 1088 L 2153 1139.5 L 2152 1139.5 L 2152.5 1088 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 116.5 1277 L 2150.5 1277 L 2151 1277.5 L 2151 1295.5 L 2150 1295.5 L 2150 1278.5 L 2149.5 1278 L 116.5 1278 L 116.5 1277 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 116.5 1296 L 117 1331.5 L 116 1331.5 L 116.5 1296 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 2149.5 1328 L 2150 1357.5 L 2149 1357.5 L 2149.5 1328 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 117.5 1364 L 118 1392.5 L 117 1392.5 L 117.5 1364 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 1.5 1387 L 2 1422.5 L 1 1422.5 L 1.5 1387 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 2148.5 1387 L 2149 1412.5 L 2148 1412.5 L 2148.5 1387 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 118.5 1415 L 119 1419.5 L 118 1419.5 L 118.5 1415 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 2147.5 1419 L 2148 1421.5 L 2147 1421.5 L 2147.5 1419 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 2264.5 1421 L 2265 1427.5 L 2264 1427.5 L 2264.5 1421 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 119.5 1422 L 120 1424.5 L 119 1424.5 L 119.5 1422 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 2.5 1429 L 3 1433.5 L 2 1433.5 L 2.5 1429 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 2263.5 1433 L 2264 1436.5 L 2263 1436.5 L 2263.5 1433 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 3.5 1437 L 4 1439.5 L 3 1439.5 L 3.5 1437 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 2141.5 1438 L 2140.5 1440 L 2141.5 1438 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 2262.5 1440 L 2263 1442.5 L 2262 1442.5 L 2262.5 1440 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 4.5 1443 L 5 1445.5 L 4 1445.5 L 4.5 1443 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 2137.5 1444 L 2136.5 1446 L 2137.5 1444 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 129.5 1445 L 131.5 1448 L 129.5 1445 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 2261.5 1445 L 2262 1447.5 L 2261 1447.5 L 2261.5 1445 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 5.5 1448 L 6 1450.5 L 5 1450.5 L 5.5 1448 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 2134.5 1448 L 2129.5 1454 L 2134.5 1448 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 139.5 1455 L 140.5 1457 L 139.5 1455 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 2125.5 1456 L 2124.5 1458 L 2125.5 1456 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 166.5 1467 L 170 1467.5 L 166.5 1468 L 166.5 1467 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 2097.5 1467 L 2101 1467.5 L 2097.5 1468 L 2097.5 1467 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 188.5 1468 L 215 1468.5 L 188.5 1469 L 188.5 1468 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 889.5 1468 L 893 1468.5 L 889.5 1469 L 889.5 1468 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 1372.5 1468 L 1377 1468.5 L 1372.5 1469 L 1372.5 1468 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 2052.5 1468 L 2079 1468.5 L 2052.5 1469 L 2052.5 1468 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 243.5 1469 L 272 1469.5 L 243.5 1470 L 243.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 884.5 1469 L 887 1469.5 L 884.5 1470 L 884.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 1994.5 1469 L 2024 1469.5 L 1994.5 1470 L 1994.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 302.5 1470 L 333 1470.5 L 302.5 1471 L 302.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 1934.5 1470 L 1965 1470.5 L 1934.5 1471 L 1934.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 365.5 1471 L 399 1471.5 L 365.5 1472 L 365.5 1471 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 1868.5 1471 L 1901 1471.5 L 1868.5 1472 L 1868.5 1471 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 434.5 1472 L 471 1472.5 L 434.5 1473 L 434.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 1795.5 1472 L 1833 1472.5 L 1795.5 1473 L 1795.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 511.5 1473 L 553 1473.5 L 511.5 1474 L 511.5 1473 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 1714.5 1473 L 1756 1473.5 L 1714.5 1474 L 1714.5 1473 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 598.5 1474 L 648 1474.5 L 598.5 1475 L 598.5 1474 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 1619.5 1474 L 1668 1474.5 L 1619.5 1475 L 1619.5 1474 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 703.5 1475 L 767 1475.5 L 703.5 1476 L 703.5 1475 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 1499.5 1475 L 1563 1475.5 L 1499.5 1476 L 1499.5 1475 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 844.5 1476 L 869 1476.5 L 844.5 1477 L 844.5 1476 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 1398.5 1476 L 1422 1476.5 L 1398.5 1477 L 1398.5 1476 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 2242.5 1497 L 2241.5 1499 L 2242.5 1497 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 24.5 1498 L 25.5 1500 L 24.5 1498 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 2239.5 1502 L 2238.5 1504 L 2239.5 1502 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 27.5 1503 L 28.5 1505 L 27.5 1503 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 29.5 1506 L 30.5 1508 L 29.5 1506 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 31.5 1509 L 32.5 1511 L 31.5 1509 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 2233.5 1511 L 2232.5 1513 L 2233.5 1511 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 33.5 1512 L 34.5 1514 L 33.5 1512 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 2230.5 1515 L 2229.5 1517 L 2230.5 1515 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 36.5 1516 L 37.5 1518 L 36.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 2227.5 1519 L 2226.5 1521 L 2227.5 1519 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 40.5 1521 L 42.5 1524 L 40.5 1521 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 2223.5 1524 L 2219.5 1529 L 2223.5 1524 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 46.5 1528 L 57.5 1540 L 46.5 1528 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 2208.5 1539 L 2205.5 1543 L 2208.5 1539 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 62.5 1543 L 64.5 1546 L 62.5 1543 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 2201.5 1545 L 2199.5 1548 L 2201.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 68.5 1548 L 69.5 1550 L 68.5 1548 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 2196.5 1549 L 2195.5 1551 L 2196.5 1549 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 72.5 1551 L 73.5 1553 L 72.5 1551 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 2192.5 1552 L 2191.5 1554 L 2192.5 1552 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 75.5 1553 L 76.5 1555 L 75.5 1553 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 2189.5 1554 L 2188.5 1556 L 2189.5 1554 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 78.5 1555 L 79.5 1557 L 78.5 1555 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 2186.5 1556 L 2185.5 1558 L 2186.5 1556 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 81.5 1557 L 82.5 1559 L 81.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 86.5 1560 L 87.5 1562 L 86.5 1560 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 2176.5 1562 L 2175.5 1564 L 2176.5 1562 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 2124.5 1581 L 2127 1581.5 L 2124.5 1582 L 2124.5 1581 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 145.5 1582 L 148 1582.5 L 145.5 1583 L 145.5 1582 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 2118.5 1582 L 2121 1582.5 L 2118.5 1583 L 2118.5 1582 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 152.5 1583 L 156 1583.5 L 152.5 1584 L 152.5 1583 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 2111.5 1583 L 2115 1583.5 L 2111.5 1584 L 2111.5 1583 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 162.5 1584 L 342 1584.5 L 162.5 1585 L 162.5 1584 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 2080.5 1584 L 2105 1584.5 L 2080.5 1585 L 2080.5 1584 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 666.5 1585 L 839.5 1585 L 841 1586.5 L 840.5 1718 L 840 1586 L 666.5 1586 L 666.5 1585 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 1853.5 1585 L 1983 1585.5 L 1853.5 1586 L 1853.5 1585 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 957.5 1586 L 958 1717.5 L 957 1717.5 L 957.5 1586 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 1261.5 1586 L 1309 1586.5 L 1261.5 1587 L 1261.5 1586 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 1425 1586 L 1609 1586.5 L 1426 1587 L 1425.5 1713 L 1425 1586 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 1426.5 1719 L 1427 1721.5 L 1426 1721.5 L 1426.5 1719 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 1309.5 1720 L 1310 1727.5 L 1309 1727.5 L 1309.5 1720 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 956.5 1726 L 957 1730.5 L 956 1730.5 L 956.5 1726 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 1310.5 1732 L 1311 1735.5 L 1310 1735.5 L 1310.5 1732 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 955.5 1735 L 956 1738.5 L 955 1738.5 L 955.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 833.5 1738 L 832.5 1740 L 833.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 1433.5 1739 L 1434.5 1741 L 1433.5 1739 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 831.5 1741 L 830.5 1743 L 831.5 1741 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 954.5 1742 L 955 1744.5 L 954 1744.5 L 954.5 1742 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 1436.5 1743 L 1438.5 1746 L 1436.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 1441.5 1748 L 1443.5 1751 L 1441.5 1748 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 822.5 1750 L 821.5 1752 L 822.5 1750 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 951.5 1756 L 952.5 1757 L 1315 1757.5 L 951 1758 L 951.5 1756 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 806.5 1757 L 809 1757.5 L 806.5 1758 L 806.5 1757 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 1458.5 1757 L 1461 1757.5 L 1458.5 1758 L 1458.5 1757 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 798.5 1758 L 802 1758.5 L 798.5 1759 L 798.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 1464.5 1758 L 1468 1758.5 L 1464.5 1759 L 1464.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 788.5 1759 L 793 1759.5 L 788.5 1760 L 788.5 1759 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 1473.5 1759 L 1478 1759.5 L 1473.5 1760 L 1473.5 1759 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 780.5 1760 L 784 1760.5 L 780.5 1761 L 780.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 1482.5 1760 L 1486 1760.5 L 1482.5 1761 L 1482.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 774.5 1761 L 777 1761.5 L 774.5 1762 L 774.5 1761 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 1489.5 1761 L 1492 1761.5 L 1489.5 1762 L 1489.5 1761 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 768.5 1762 L 771 1762.5 L 768.5 1763 L 768.5 1762 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 1495.5 1762 L 1498 1762.5 L 1495.5 1763 L 1495.5 1762 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 763.5 1763 L 766 1763.5 L 763.5 1764 L 763.5 1763 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 1500.5 1763 L 1503 1763.5 L 1500.5 1764 L 1500.5 1763 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 1566.5 1787 L 1567.5 1789 L 1566.5 1787 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 696.5 1789 L 695.5 1791 L 696.5 1789 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 1571.5 1790 L 1572.5 1792 L 1571.5 1790 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 688.5 1794 L 687.5 1796 L 688.5 1794 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 1580.5 1796 L 1581.5 1798 L 1580.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 1583.5 1798 L 1584.5 1800 L 1583.5 1798 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 681.5 1799 L 680.5 1801 L 681.5 1799 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 1587.5 1801 L 1588.5 1803 L 1587.5 1801 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 677.5 1802 L 675.5 1805 L 677.5 1802 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 1592.5 1805 L 1594.5 1808 L 1592.5 1805 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 671.5 1807 L 668.5 1811 L 671.5 1807 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 1600.5 1812 L 1607.5 1820 L 1600.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 657.5 1821 L 654.5 1825 L 657.5 1821 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 1611.5 1824 L 1613.5 1827 L 1611.5 1824 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 651.5 1828 L 650.5 1830 L 651.5 1828 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 1616.5 1830 L 1617.5 1832 L 1616.5 1830 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 648.5 1832 L 647.5 1834 L 648.5 1832 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 1621.5 1837 L 1622.5 1839 L 1621.5 1837 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 640.5 1844 L 639.5 1846 L 640.5 1844 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 1627.5 1847 L 1628.5 1849 L 1627.5 1847 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 802.5 1875 L 808 1875.5 L 802.5 1876 L 802.5 1875 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 1459.5 1875 L 1464 1875.5 L 1459.5 1876 L 1459.5 1875 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 795.5 1876 L 798 1876.5 L 795.5 1877 L 795.5 1876 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 1468.5 1876 L 1472 1876.5 L 1468.5 1877 L 1468.5 1876 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 789.5 1877 L 792 1877.5 L 789.5 1878 L 789.5 1877 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 1474.5 1877 L 1477 1877.5 L 1474.5 1878 L 1474.5 1877 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 1641.5 1883 L 1642 1885.5 L 1641 1885.5 L 1641.5 1883 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 624.5 1885 L 625 1887.5 L 624 1887.5 L 624.5 1885 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 755.5 1890 L 754.5 1892 L 755.5 1890 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 623.5 1891 L 624 1893.5 L 623 1893.5 L 623.5 1891 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 1512.5 1891 L 1513.5 1893 L 1512.5 1891 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 752.5 1892 L 751.5 1894 L 752.5 1892 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 1516.5 1894 L 1518.5 1897 L 1516.5 1894 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 1643.5 1894 L 1644 1896.5 L 1643 1896.5 L 1643.5 1894 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 748.5 1895 L 743.5 1901 L 748.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 622.5 1897 L 623 1899.5 L 622 1899.5 L 622.5 1897 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 1522.5 1900 L 1524.5 1903 L 1522.5 1900 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 1644.5 1900 L 1645 1902.5 L 1644 1902.5 L 1644.5 1900 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 621.5 1903 L 622 1905.5 L 621 1905.5 L 621.5 1903 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 741.5 1903 L 740.5 1905 L 741.5 1903 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 1645.5 1906 L 1646 1908.5 L 1645 1908.5 L 1645.5 1906 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 620.5 1909 L 621 1911.5 L 620 1911.5 L 620.5 1909 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 1527.5 1909 L 1528 1911.5 L 1527 1911.5 L 1527.5 1909 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 738.5 1911 L 739 1914.5 L 738 1914.5 L 738.5 1911 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 1646.5 1912 L 1647 1914.5 L 1646 1914.5 L 1646.5 1912 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 619.5 1915 L 620 1917.5 L 619 1917.5 L 619.5 1915 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 1528.5 1915 L 1529 1917.5 L 1528 1917.5 L 1528.5 1915 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 737.5 1918 L 738 1920.5 L 737 1920.5 L 737.5 1918 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 1647.5 1918 L 1648 1920.5 L 1647 1920.5 L 1647.5 1918 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 618.5 1921 L 619 1923.5 L 618 1923.5 L 618.5 1921 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 1529.5 1921 L 1530 1923.5 L 1529 1923.5 L 1529.5 1921 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 736.5 1924 L 737 1926.5 L 736 1926.5 L 736.5 1924 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 1648.5 1925 L 1649 1927.5 L 1648 1927.5 L 1648.5 1925 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 617.5 1927 L 618 1929.5 L 617 1929.5 L 617.5 1927 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 1530.5 1927 L 1531 1930.5 L 1530 1930.5 L 1530.5 1927 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 735.5 1930 L 736 1932.5 L 735 1932.5 L 735.5 1930 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 1649.5 1931 L 1650 1933.5 L 1649 1933.5 L 1649.5 1931 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 616.5 1933 L 617 1935.5 L 616 1935.5 L 616.5 1933 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 1531.5 1934 L 1532 1936.5 L 1531 1936.5 L 1531.5 1934 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 734.5 1936 L 735 1938.5 L 734 1938.5 L 734.5 1936 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 1650.5 1937 L 1651 1939.5 L 1650 1939.5 L 1650.5 1937 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 615.5 1939 L 616 1941.5 L 615 1941.5 L 615.5 1939 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 1532.5 1940 L 1533 1942.5 L 1532 1942.5 L 1532.5 1940 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 733.5 1942 L 734 1944.5 L 733 1944.5 L 733.5 1942 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 1651.5 1943 L 1652 1945.5 L 1651 1945.5 L 1651.5 1943 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 614.5 1945 L 615 1947.5 L 614 1947.5 L 614.5 1945 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 1533.5 1946 L 1534 1948.5 L 1533 1948.5 L 1533.5 1946 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 732.5 1948 L 733 1950.5 L 732 1950.5 L 732.5 1948 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 1652.5 1949 L 1653 1951.5 L 1652 1951.5 L 1652.5 1949 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 613.5 1951 L 614 1953.5 L 613 1953.5 L 613.5 1951 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 1534.5 1952 L 1535 1954.5 L 1534 1954.5 L 1534.5 1952 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 731.5 1954 L 732 1956.5 L 731 1956.5 L 731.5 1954 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 1653.5 1955 L 1654 1957.5 L 1653 1957.5 L 1653.5 1955 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 612.5 1957 L 613 1959.5 L 612 1959.5 L 612.5 1957 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 1535.5 1958 L 1536 1960.5 L 1535 1960.5 L 1535.5 1958 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 730.5 1960 L 731 1963 L 1536 1963.5 L 730 1964 L 730.5 1960 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 1654.5 1962 L 1655 1964.5 L 1654 1964.5 L 1654.5 1962 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 611.5 1964 L 612 1966.5 L 611 1966.5 L 611.5 1964 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 1655.5 1968 L 1656 1971.5 L 1655 1971.5 L 1655.5 1968 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 610.5 1970 L 611 1975.5 L 610 1975.5 L 610.5 1970 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 610.5 1986 L 611 1991.5 L 610 1991.5 L 610.5 1986 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 1655.5 1990 L 1656 1993.5 L 1655 1993.5 L 1655.5 1990 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 611.5 1995 L 612 1997.5 L 611 1997.5 L 611.5 1995 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 1654.5 1997 L 1655 1999.5 L 1654 1999.5 L 1654.5 1997 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 621.5 2024 L 622.5 2026 L 621.5 2024 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 1642.5 2028 L 1641.5 2030 L 1642.5 2028 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 624.5 2029 L 625.5 2031 L 624.5 2029 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 1640.5 2031 L 1639.5 2033 L 1640.5 2031 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 1637.5 2035 L 1636.5 2037 L 1637.5 2035 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 629.5 2036 L 631.5 2039 L 629.5 2036 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 1633.5 2040 L 1624.5 2050 L 1633.5 2040 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 644.5 2051 L 646.5 2054 L 644.5 2051 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 1619.5 2053 L 1618.5 2055 L 1619.5 2053 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 649.5 2055 L 650.5 2057 L 649.5 2055 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 1615.5 2056 L 1614.5 2058 L 1615.5 2056 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 652.5 2057 L 653.5 2059 L 652.5 2057 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 1612.5 2058 L 1611.5 2060 L 1612.5 2058 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 655.5 2059 L 656.5 2061 L 655.5 2059 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 699.5 2077 L 702 2077.5 L 699.5 2078 L 699.5 2077 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 704.5 2078 L 708 2078.5 L 704.5 2079 L 704.5 2078 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 1559.5 2078 L 1562 2078.5 L 1559.5 2079 L 1559.5 2078 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 712.5 2079 L 717 2079.5 L 712.5 2080 L 712.5 2079 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 1550.5 2079 L 1555 2079.5 L 1550.5 2080 L 1550.5 2079 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 731.5 2080 L 865 2080.5 L 731.5 2081 L 731.5 2080 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 1401.5 2080 L 1535 2080.5 L 1401.5 2081 L 1401.5 2080 Z"
          fill="currentColor"
          fillOpacity="0.6039216"
          stroke="currentColor"
          strokeOpacity="0.6039216"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 1045.5 0 L 1220.5 0 L 1221.5 1 L 1223.5 0 L 1224.5 1 L 1909.5 2 L 1910.5 3 L 2082.5 3 L 2083.5 4 L 2109.5 4 L 2140.5 10 L 2164.5 19 Q 2196.4 34.1 2219 58.5 Q 2238.4 79.6 2251 107.5 L 2261 138.5 L 2264 155.5 L 2264 166.5 L 2265 167.5 L 2265 338.5 L 2266 339.5 L 2266 905.5 L 2265 906.5 L 2265 1420.5 L 2264 1421.5 L 2264 1432.5 L 2258 1461.5 Q 2252.1 1480.6 2243 1496.5 Q 2229.3 1520.8 2209.5 1539 Q 2190 1557 2164.5 1569 L 2140.5 1578 L 2110.5 1584 L 2080.5 1584 L 2079.5 1585 L 1853.5 1585 L 1852.5 1586 L 1425 1586 L 1425 1712.5 L 1426 1713.5 L 1426 1721.5 Q 1430.1 1740.9 1443.5 1751 L 1454.5 1757 L 1504.5 1764 L 1520.5 1768 L 1545.5 1777 Q 1584.6 1793.9 1611 1823.5 Q 1629.5 1844 1639 1873.5 L 1654 1958.5 L 1654 1964.5 L 1656 1972.5 L 1656 1989.5 L 1653 2005.5 L 1646 2022.5 Q 1636 2040.5 1620.5 2053 Q 1605.8 2064.8 1586.5 2072 L 1569.5 2077 L 1558.5 2079 L 1550.5 2079 L 1549.5 2080 L 1401.5 2080 L 1400.5 2081 L 865.5 2081 L 864.5 2080 L 717.5 2080 L 716.5 2079 L 702.5 2078 Q 657 2069 632 2039.5 Q 621.4 2027.1 615 2010.5 L 611 1994.5 L 610 1976.5 L 611 1975.5 L 612 1960.5 L 613 1959.5 L 625 1882.5 L 630 1865.5 Q 643.3 1832.8 667.5 1811 Q 691.3 1789.3 723.5 1776 Q 741 1768.5 761.5 1764 L 784.5 1760 L 808.5 1758 Q 823.9 1753.4 832 1741.5 L 837 1732.5 L 841 1717.5 L 841 1586.5 L 839.5 1585 L 342.5 1585 L 341.5 1584 L 156.5 1584 L 155.5 1583 L 137.5 1581 L 122.5 1577 Q 104 1571 88.5 1562 Q 62 1547 43 1524.5 Q 26.1 1504.9 15 1479.5 L 7 1456.5 L 2 1428.5 L 2 1387.5 L 1 1386.5 L 1 364.5 L 2 363.5 L 2 159.5 L 3 158.5 L 4 145.5 Q 18.1 80.6 61.5 45 Q 81.1 28.1 106.5 17 L 129.5 9 L 156.5 4 L 183.5 4 L 184.5 3 L 355.5 3 L 356.5 2 L 1044.5 1 L 1045.5 0 Z M 1112 115 L 1111 116 L 586 118 L 585 119 L 167 120 Q 151 123 141 131 Q 123 143 118 169 L 117 371 L 116 372 L 116 512 L 115 513 L 115 677 L 114 678 L 114 1142 L 115 1143 L 115 1161 L 116 1161 L 2152 1161 L 2152 1141 L 2153 1140 L 2153 1027 L 2154 1026 L 2154 563 L 2153 562 L 2153 449 L 2152 448 L 2152 364 L 2151 363 L 2151 293 L 2150 292 L 2149 176 L 2148 175 L 2148 167 L 2144 154 L 2135 140 Q 2126 129 2112 123 L 2100 120 L 2079 120 L 2078 119 L 1948 118 L 1947 117 L 1861 117 L 1860 116 L 1743 116 L 1742 115 L 1112 115 Z M 116 1277 L 118 1420 Q 121 1435 129 1446 Q 138 1458 153 1464 L 167 1468 L 188 1468 L 189 1469 L 365 1471 L 366 1472 L 434 1472 L 435 1473 L 511 1473 L 512 1474 L 703 1475 L 704 1476 L 844 1476 L 845 1477 L 869 1477 L 880 1471 L 894 1468 L 1372 1468 L 1387 1471 L 1399 1477 L 1422 1477 L 1423 1476 L 1563 1476 L 1564 1475 L 1756 1474 L 1757 1473 L 1833 1473 L 1834 1472 L 1901 1472 L 1902 1471 L 2079 1469 L 2080 1468 L 2101 1468 L 2109 1466 Q 2121 1462 2130 1454 Q 2143 1442 2148 1422 L 2148 1414 L 2149 1413 L 2149 1359 L 2150 1358 L 2150 1297 L 2151 1296 L 2151 1278 L 2151 1277 L 116 1277 Z M 957 1586 L 957 1726 L 956 1727 L 955 1742 L 951 1757 L 952 1758 L 1315 1758 L 1311 1740 L 1310 1721 L 1309 1720 L 1309 1586 L 957 1586 Z M 803 1875 L 802 1876 L 790 1877 L 770 1883 L 749 1895 Q 742 1900 739 1908 L 731 1960 L 730 1961 L 731 1964 L 1536 1964 L 1528 1910 L 1525 1903 Q 1515 1890 1500 1884 L 1477 1877 L 1465 1876 L 1464 1875 L 803 1875 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'ComputerFourth')

export default icon
